import { Grid, GridProps } from '@mui/material';
import { useField } from 'formik';
import { Select, SelectProps } from '../../../../../atomic/input/select';
import { FormFieldWrapper } from '../../shared/formFieldWrapper';
import { useAdditionalOnChange } from '../hooks/useAdditionalOnChange';
import { FormFieldProps } from '../index';

export type FormSelectProps = FormFieldProps &
  Omit<SelectProps, 'onChange' | 'helperText'> &
  Pick<GridProps, 'lg' | 'md' | 'sm' | 'xl' | 'xs'>;

export const FormSelect = FormFieldWrapper<FormSelectProps>(
  ({ additionalOnChange, ...props }) => {
    const [field, meta] = useField<unknown>({
      name: props.name
    });

    const onChange = useAdditionalOnChange(field.onChange, additionalOnChange);

    return (
      <Grid item xs={props.xs ?? 12} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
        <Select
          {...props}
          label={props.label}
          name={field.name}
          value={field.value}
          onChange={onChange}
          onBlur={field.onBlur}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.error}
          options={props.options}
        />
      </Grid>
    );
  },
  (props: FormSelectProps) => (props.multiple ? [] : '')
);
